import React, { useMemo } from 'react';
import styled from 'styled-components';
import { useObjectImages } from '../../../../../generic/hooks/useObjectImages';
import { ImageObjectType } from '../../../../../modules/API/Images/models/imageObject';
import OrderImagesBlock from '../../drivers/Components/OrderImagesBlock';

interface Props {
    problemID: number;
    /** Инжектится AppModal. */
    closeFunc?: () => void;
}

/** Фото и комментарий проблемы. Запрос уходит только при открытии модалки. */
const ProblemImagesModal: React.FC<Props> = ({ problemID }) => {
    const ref = useMemo(
        () => ({ ObjectType: ImageObjectType.PROBLEM, ObjectID: problemID, ObjectSubID: 0 }),
        [problemID],
    );
    const { images, comment, isLoading, hasError } = useObjectImages(ref);

    // OrderImagesBlock при пустом ответе не рендерит ничего — показываем заглушку сами.
    if (!isLoading && (hasError || (images.length === 0 && !comment.trim()))) {
        return <EmptyText>{hasError ? 'שגיאה בטעינת תמונות' : 'אין תמונות או הערות'}</EmptyText>;
    }

    return (
        <Shell>
            <OrderImagesBlock
                images={images}
                comment={comment}
                isLoading={isLoading}
                commentFirst
            />
        </Shell>
    );
};

export default ProblemImagesModal;

const Shell = styled.div`
    direction: rtl;
`;

const EmptyText = styled.p`
    margin: 0;
    padding: 1rem 0;
    text-align: center;
    font-family: ${({ theme }) => theme.fonts.sans};
    font-size: ${({ theme }) => theme.text.md};
    color: ${({ theme }) => theme.colors.ink4};
`;
